import axios from 'axios';
import apiClient from './apiClient';

// Базовый клиент
const inventoryClient = apiClient('');

const inventoryApi = {
    // Получить инвентарь по ID пользователя
    async getInventoryByUserId(userId) {
        try {
            const response = await inventoryClient.get(`/gems/${userId}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при получении инвентаря пользователя ${userId}:`, error);
            throw error;
        }
    },

    // Добавить гем пользователю
    async addGemToUserInventory(data) {
        try {
            const response = await inventoryClient.post('/gems', data);
            return response.data;
        } catch (error) {
            console.error('Ошибка при добавлении гема:', error);
            throw error;
        }
    },

    // Увеличить количество гема
    async increaseGem(data) {
        try {
            const response = await inventoryClient.patch('/gems/increase', data);
            return response.data;
        } catch (error) {
            console.error('Ошибка при увеличении гема:', error);
            throw error;
        }
    },

    // Уменьшить количество гема
    async decreaseGem(data) {
        try {
            const response = await inventoryClient.patch('/gems/decrease', data);
            return response.data;
        } catch (error) {
            console.error('Ошибка при уменьшении гема:', error);
            throw error;
        }
    },

    // Получить случайный гем
    async getRandomGem(data) {
        try {
            const response = await inventoryClient.post('/gems/random', data);
            return response.data;
        } catch (error) {
            console.error('Ошибка при получении случайного гема:', error);
            throw error;
        }
    },

    // Получить весь инвентарь (admin)
    async getAllInventories(page = 1, limit = 10) {
        try {
            const response = await inventoryClient.get(`/gems/admin/list?page=${page}&limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error('Ошибка при получении инвентаря:', error);
            throw error;
        }
    }
};

const gemCatalogApi = {
    // Получить все типы гемов
    async getAllGems() {
        try {
            const response = await inventoryClient.get('/gem-types');
            return response.data;
        } catch (error) {
            console.error('Ошибка при получении списка типов гемов:', error);
            throw error;
        }
    },

    // Получить один тип гема по ID
    async getGemById(id) {
        try {
            const response = await inventoryClient.get(`/gem-types/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при получении гема с ID ${id}:`, error);
            throw error;
        }
    },

    // Создать новый тип гема (с поддержкой multipart/form-data)
    async createGem(gemData) {
        try {
            const response = await axios.post(
                '/gem-types',
                gemData,
                {
                    baseURL: inventoryClient.defaults.baseURL,
                    withCredentials: true,
                }
            );
            return response.data;
        } catch (error) {
            console.error('Ошибка при создании гема:', error);
            throw error;
        }
    },

    // Обновить тип гема (с поддержкой multipart/form-data)
    async updateGem(id, gemData) {
        try {
            const response = await axios.put(
                `/gem-types/${id}`,
                gemData,
                {
                    baseURL: inventoryClient.defaults.baseURL,
                    withCredentials: true,
                }
            );
            return response.data;
        } catch (error) {
            console.error(`Ошибка при обновлении гема с ID ${id}:`, error);
            throw error;
        }
    },

    // Удалить тип гема
    async deleteGem(id) {
        try {
            const response = await inventoryClient.delete(`/gem-types/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при удалении гема с ID ${id}:`, error);
            throw error;
        }
    }
};

export default {
    inventoryApi,
    gemCatalogApi
};
